import { type ReactNode } from "react";

const ANIMATION_CSS = `
@keyframes dashboard-shell-enter {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.dashboard-shell {
  animation: dashboard-shell-enter 200ms ease-out both;
}

.dashboard-shell .dashboard-segmented-button:hover {
  color: var(--login-text) !important;
  background: color-mix(in srgb, var(--login-accent) 8%, transparent) !important;
}

.dashboard-shell .dashboard-segmented-button[data-active="true"],
.dashboard-shell .dashboard-segmented-button[data-active="true"]:hover {
  color: var(--selection-ink) !important;
  background: var(--selection-surface) !important;
}

.dashboard-shell .dashboard-segmented-button:active {
  transform: translateY(1px);
}

.dashboard-shell .dashboard-segmented-button:focus-visible,
.dashboard-shell button:focus-visible {
  outline: 2px solid var(--login-accent);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .dashboard-shell {
    animation: none !important;
  }

  .dashboard-shell .dashboard-segmented-button {
    transition: none !important;
    transform: none !important;
  }
}
`;

export function DashboardShell({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="dashboard-shell"
      className="dashboard-shell"
      style={{
        width: "100%",
        padding: "clamp(0.75rem, 2vw, 1.5rem)",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        maxWidth: "1180px",
        minWidth: 0,
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      <style>{ANIMATION_CSS}</style>
      {children}
    </div>
  );
}
